module.exports = __webpack_public_path__ + "static/students_flyers.3badffc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/students_flyers.jpg
// module id = 141
// module chunks = 35783957827783 179562081087140